import { parseTwentyFourHour } from '~/utils/parseTwentyFourHour'

export const formatTwentyFourHourTime = (value: string) => {
  if (!value) return ''
  const parsed = parseTwentyFourHour(value)
  if (!parsed.isValid()) return value
  return parsed.format('h:mma')
}
